import React from 'react';
import Axios from 'axios';

import moment from 'moment';
import Users from '../../users/Users';

import QvneaBooksOperations from './QvneaBooksOperations';
import QvneaBooksSummary from './QvneaBooksSummary';
import QvneaBooksPlayerAccount from './QvneaBooksPlayerAccount';


const ADMIN_LVL_MASTER = 0;				// same as Users.js
const ADMIN_LVL_ADMINLIMIT = 20;	// same as Users.js

class QvneaBooks extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			pageOption: "operations",
			isAdmin: false,
		};

		this.summaryButtonClicked = this.summaryButtonClicked.bind(this);
		this.operationsButtonClicked = this.operationsButtonClicked.bind(this);
		this.playerAccountButtonClicked = this.playerAccountButtonClicked.bind(this);
	}

	render() {
		console.log('QvneaBooks: render');
		console.log(this.state)

		var summaryBtnClass = 'btn-primary';
		var operationsBtnClass = 'btn-primary';
		var playerAccountBtnClass = 'btn-primary';

		if (this.state.pageOption === "operations") {
			summaryBtnClass = 'btn-secondary';			
			playerAccountBtnClass = 'btn-secondary';	

		} else if (this.state.pageOption === "summary") {
			operationsBtnClass = 'btn-secondary';
			playerAccountBtnClass = 'btn-secondary';

		} else {
			summaryBtnClass = 'btn-secondary';			
			operationsBtnClass = 'btn-secondary';
		}

		return (
			<div className="animated fadeIn">
        <div className="row">
        <div className="col-12">
          <h4>QVNEA Finances</h4>
          <p>LA PUISSANCE DES STATS</p>
	        <hr/>
				</div>
				</div>

				<div className="row">
				<div className="col-md-12">
					<button className={"btn " + operationsBtnClass + " btn-margin-right-10"} onClick={this.operationsButtonClicked}>
						QVNEA Opérations
					</button>

					<button className={"btn " + summaryBtnClass + " btn-margin-right-10"} onClick={this.summaryButtonClicked}>
						QVNEA Sommaire
					</button>

					<button className={"btn " + playerAccountBtnClass + " btn-margin-right-10"} onClick={this.playerAccountButtonClicked}>
						QVNEA Compte Joueur
					</button>

					<br/><br/>
				</div>
				</div>

				{(this.state.pageOption === "operations") ? 
					<QvneaBooksOperations /> 
					: null}

				{(this.state.pageOption === "summary") ? 
					<QvneaBooksSummary /> 
					: null}

				{(this.state.pageOption === "playerAccount") ? 
					<QvneaBooksPlayerAccount /> 
					: null}

      </div>
		);
	}

	summaryButtonClicked() {
		if (this.state.pageOption !== "summary") {
			this.setState({
				pageOption: "summary"
			});
		}
	}

	operationsButtonClicked() {
		if (this.state.pageOption !== "operations") {
			this.setState({
				pageOption: "operations"
			});
		}
	}

	playerAccountButtonClicked() {
		if (this.state.pageOption !== "playerAccount") {
			this.setState({
				pageOption: "playerAccount"
			});
		}
	}

}

export default QvneaBooks;
